var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"disabled":_vm.disabled,"icon":_vm.icon,"label":_vm.label,"loading":_vm.loading,"remove":_vm.remove,"save":_vm.save,"type":_vm.type,"design":"text"},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }